import React from "react";
import styles from "./ConfigurationIssuesModal.module.css";
import classnames from "classnames";
import {CloseImageButton} from "../../../closeImageButton/CloseImageButton";
import {formatDateTime} from "../../../../../utils/dateTimeUtil";

type ModalTone = "error" | "warning";

interface ModalIssue {
    message: string;
    field?: string;
    updatedAt?: string;
}

interface ConfigurationIssuesModalProps {
    issues: ModalIssue[];
    title?: string;
    tone?: ModalTone;
    handleClose: (value?: any) => any
}

export const ConfigurationIssuesModal: React.FC<ConfigurationIssuesModalProps> = ({
                                                                                      issues,
                                                                                      title = "Configuration issues",
                                                                                      tone = "error",
                                                                                      handleClose
                                                                                  }) => {
    const formatValidatedAt = (updatedAt?: string) => {
        if (!updatedAt) {
            return null;
        }

        const {date, time, timezone} = formatDateTime(updatedAt, "Europe/London");
        return `Validated at ${date}, ${time} ${timezone}`;
    };

    return <div className={styles.container}>
        <div className={styles.titleRow}>
            <h2 className={classnames(styles.title, styles[`${tone}Title`])}>{title}</h2>
            <CloseImageButton onClose={handleClose}/>
        </div>
        <ul className={styles.list}>
            {issues.map((issue, index) => {
                const validatedAt = formatValidatedAt(issue.updatedAt);

                return <li key={index} className={classnames(styles.item, styles[`${tone}Item`])}>
                    <span className={styles.message}>{issue.message}</span>
                    {issue.field && <span className={styles.field}>{issue.field}</span>}
                    {validatedAt && <span className={styles.timestamp}>{validatedAt}</span>}
                </li>;
            })}
        </ul>
    </div>
}
